<template>
    <main-content>
        <kt-panel>
            <kt-panel-body>
                <ticket-form :action="createTicket"></ticket-form>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import $ from 'jquery'
import { KTApp } from '@/plugins/core/app'
import { KTUtil } from '@/plugins/core/util'
import { ticketService } from '@/common/api.service'
import ticketForm from './components/form'
import mainContent from '@/components/main-content'

export default {
    components: {
        ticketForm,
        mainContent
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.dispatch('user/fetchForSelect')
        })
    },
    methods: {
        createTicket(e, query) {
            let form = $(e.target)
            let btn = $('#submit_button')

            form.validate({
                ignore: ":hidden",

                rules: {
                    subject: {
                        required: true,
                    },
                    category_id: {
                        required: true,
                    },
                    content: {
                        required: true,
                    },
                    priority: {
                        required: true,
                    },
                },
            });


            if(!form.valid()) {
                return
            }

            KTApp.progress(btn)
            ticketService.create(query)
            .then(response => {
                this.$router.push('/tickets')
                this.showMsg(form, 'success', response.data.message)
                this.$store.dispatch('badgeCounter/countData')
            })
            .catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
            })
            .finally(() => {
                KTUtil.scrollTop()
                KTApp.unprogress(btn)
            })
        }
    }
}
</script>

<style>

</style>